/* Built In Imports */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* Internal Imports */
/* Components */
import config from '@config';

/**
 *
 * @param {Object} pageData
 * @param {String} region
 * @returns
 */
export const usePageConfigValue = (pageData, region, currentCoupon) => {
  const [isThemeActive, setIsThemeActive] = useState(false);
  const [isCountryVisible, setIsCountryVisible] = useState(false);
  const currPage = '';
  const router = useRouter();

  const { pageConfig, country } = pageData || {};

  const pageConfigVal = pageConfig?.[0]?.value;
  const visibleCountries = pageConfigVal?.visibleCountries;
  const visibleRegions = pageConfigVal?.visibleRegions;
  const visibleGroupCountries = pageConfigVal?.visibleGroupCountries;

  const isPageVal =
    pageConfig?.length &&
    !pageConfigVal?.disabled &&
    pageConfigVal &&
    currentCoupon?.couponCode;

  useEffect(() => {
    // console.log('country', country);
    if (country) {
      let isVisible = false;
      if (visibleCountries?.length && visibleCountries.indexOf('all') > -1) {
        isVisible = true;
      } else {
        isVisible = visibleCountries?.some(
          c => c?.toUpperCase() === country?.toUpperCase()
        );
      }

      if (!isVisible) {
        if (visibleRegions?.length && visibleRegions.indexOf('all') > -1) {
          isVisible = true;
        } else {
          isVisible = visibleRegions?.some(
            c => c?.toUpperCase() === region?.toUpperCase()
          );
        }
      }

      if (!isVisible) {
        if (
          visibleGroupCountries?.length &&
          visibleGroupCountries.indexOf('all') > -1
        ) {
          isVisible = true;
        } else {
          visibleGroupCountries?.forEach(group => {
            if (!isVisible) {
              if (group?.toLowerCase() === 'me') {
                isVisible =
                  config.middleEastCountries.indexOf(country?.toUpperCase()) >
                  -1;
              } else if (group?.toLowerCase() === 'europe') {
                isVisible =
                  config.europeanCountries.indexOf(country?.toUpperCase()) > -1;
              } else if (group?.toLowerCase() === 'latam') {
                isVisible =
                  config.latinAmericaCountries.indexOf(country?.toUpperCase()) >
                  -1;
              } else if (group?.toLowerCase() === 'apac') {
                isVisible =
                  config.apacCountries.indexOf(country?.toUpperCase()) > -1;
              } else if (group?.toLowerCase() === 'africa') {
                isVisible =
                  config.africanCountries.indexOf(country?.toUpperCase()) > -1;
              } else if (group?.toLowerCase() === 'eu') {
                isVisible =
                  config.ukCountries.indexOf(country?.toUpperCase()) > -1;
              } else if (group?.toLowerCase() === 'russia') {
                isVisible =
                  config.russianCountries.indexOf(country?.toUpperCase()) > -1;
              }
            }
          });
        }
      }
      if (isVisible) {
        setIsCountryVisible(isVisible);
      }
    }
  }, [country]);

  useEffect(
    () => () => {
      if (
        currPage &&
        router.asPath &&
        currPage?.split('#')[0] !== router.asPath?.split('#')[0]
      ) {
        setIsThemeActive(false);
      }
      // console.log('isThemeActive11', isThemeActive);
    },
    [router.asPath]
  );

  useEffect(() => {
    setIsThemeActive(isPageVal && isCountryVisible);
  }, [isCountryVisible, isPageVal]);

  return { pageConfigVal, isPageVal, isThemeActive, setIsThemeActive };
};
